<template lang="pug">
    v-content
        v-toolbar(flat="" color="white")
            v-toolbar-title מגדיר SMS
            v-divider.mx-2(inset="" vertical="")
            v-spacer
            v-dialog(v-model="dialog" max-width="800px").rtl
                v-btn.mb-2(slot="activator" color="primary" dark="") SMS חדש
                v-card
                    v-card-title
                        span.headline {{ formTitle }}
                    v-card-text
                        v-container(grid-list-md="").rtl
                            v-layout(wrap="")
                                v-flex(xs12)
                                    v-text-field(reverse right v-model="editedItem.description" label="תיאור")
                                v-flex(xs12).ltr
                                  v-switch(v-model="editedItem.is_active" label="סמס פעיל")
                                v-flex(xs12).ltr
                                    v-textarea(solo v-model="editedItem.sql" label="SQL")

                    v-card-actions
                        v-spacer
                        v-btn(color="blue darken-1" flat="" @click="close") Cancel
                        v-btn(color="blue darken-1" flat="" @click="save(editedItem)") Save
        v-data-table#setting-table.elevation-1(
                :headers="headers"
                :items="desserts"
                :loading='loading'
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
            )
            template(slot="items" slot-scope="props")
                td.text-xs-right {{ props.item.id }}
                td.text-xs-right(:style="'color: ' + (+props.item.is_active ? 'green' : 'red') + '; font-weight: bold;'") {{ props.item.is_active }}
                td.text-xs-right {{ props.item.description }}

                td.justify-center.layout.px-0
                    v-icon.ml-4(small="" @click="deleteItem(props.item)") delete
                    v-icon.ml-4(small="" @click="editItem(props.item)") edit
                    v-tooltip.v-icon.ml-4(top)
                        v-icon(slot='activator' small @click="save(props.item, true)") repeat_one
                        span שכפל
</template>

<script>
    export default {
        data: () => ({
            sort_options_system: {ASC : 'ישר', DESC : 'הפוך'},
            sort_options: [{value : 'ASC', he_value : 'ישר'}, {value : 'DESC', he_value : 'הפוך'}],
            loading: true,
            dialog: false,
            rowsPerPageItems: [10, 20, 50, 100, 1000],
            pagination: {
                rowsPerPage: 1000
            },
            headers: [
                { text: 'id'               , value: 'id'                          , sortable: false, align : 'right'},
                { text: 'פעיל?'            , value: 'is_active'                 , sortable: false, align : 'right' },
              { text: 'תיאור'            , value: 'description'                 , sortable: false, align : 'right' },
              { text: 'פעולות'                                                  , sortable: false, align : 'right' },
            ],
            columns_style: [],
            desserts: [],
            editedItem: {
              style : {},
              meta : { search_fields: [{}] },
            },
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'הגדרת SMS חדשה' : 'ערוך הגדרת SMS'
            }
        },

        watch: {
            dialog (val) {
                val || this.close()
            }
        },

        created () {
          document.title = 'הגדרות SMS';

          this.$socket.on('*', (packet) => {
                let channel = packet.data[0];
                let data = packet.data[1];
                let $uniqid = data.$uniqid;
                if($uniqid) {
                    return this.$socket.res(data);
                }
                this.sockets(channel, data);
            });

            this.initialize()
            this.$emit('update:loading', false);
        },
        beforeRouteLeave(to, from, next) {
            this.$socket.off('*');
            this.$emit('update:loading', true);
            next();
        },

        methods: {

            initialize () {
                this.$socket.req('sms.sms.settings.all').then(data => {
                  // console.log(data)
                    this.desserts = data.entities;
                        setTimeout(() => {
                            document.getElementsByClassName('v-table__overflow')[0].scrollLeft = 20000;
                            this.loading = false;
                        });
                });
            },

            sockets : function (channel, data) {
                let channels = {
                  'sum.channel' : (/*data*/) => {
                        //console.log('sum.channel', data)
                    }
                };
                if(!channels[channel]) {
                    return console.log('Socket channel not found:', channel);
                }

                return channels[channel](data);
            },

            editItem (item) {
                this.editedIndex = this.desserts.indexOf(item) || {};
                this.editedItem = Object.assign({style : {}}, item);
                this.dialog = true
            },

            deleteItem (item) {

                confirm(`בטוח? למחוק את
                    ${item.name}
                `) && this.$socket.req('sms.sms.settings.delete', {
                    id    : item.id
                }).then(() => {
                    this.initialize();
                });
            },


            close () {
                this.dialog = false
            },

            save (item, duplicate = false) {
                this.loading = true;

                if (duplicate) {
                    item = { ...item };
                    delete item['id'];
                    item['name'] = `(${item['name']})` + 'מסך חדש' + ' ' + Date.now();
                }

                this.$socket.req('sms.sms.settings.editOrAdd', item).then(() => {
                  this.editedItem = {}
                  this.initialize();
                  setTimeout(()=>{
                    this.loading = false;
                  }, 1000)
                });
                this.close();
            }
        }
    }
</script>

<style lang="sass">

    #setting-table .v-table__overflow
        /*height: 300px;*/
        overflow-y: auto
        /*direction: rtl;*/


    #setting-table .v-datatable.v-table
        direction: rtl

    #setting-table .v-datatable__actions
        direction: ltr


    .v-content__wrap
        background: #fff
    #setting-table
        table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child)
            padding: 0 5px

    .v-tooltip.v-icon span
        display: inline-flex


</style>